var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-switch",class:{ 'isChecked': _vm.checked }},[_c('span',{staticClass:"ui-switch__core",style:({ 'background': _vm.checked ? _vm.activeColor : _vm.inactiveColor, 
            'borderColor': _vm.checked ? _vm.activeColor : _vm.inactiveColor })})])}
var staticRenderFns = []

export { render, staticRenderFns }